
import { computed, defineComponent, onMounted, PropType, Ref, ref, watch, watchEffect } from 'vue'
import { select, interpolateNumber } from 'd3'

export enum CounterStyle {
  Default = 'default',
  Error = 'error',
  Warn = 'warn',
  Success = 'success',
}

export default defineComponent({
  name: 'CountTo',
  props: {
    value: [Number, Object] as PropType<number> | PropType<Ref>,
    start: {
      type: Number,
      default: 0
    },
    track: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    unit: {
      type: String,
      default: ''
    },
    prependUnit: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 120
    },
    height: {
      type: Number,
      default: 120
    },
    duration: {
      type: Number,
      default: 2500
    },
    interpolate: {
      type: [Number, Object] as PropType<number> | PropType<Ref>,
      default: 1
    },
    minDuration: {
      type: Number
    },
    color: {
      type: String,
      default: '#4b79f0',
    },
    counterStyle: {
      type: String as PropType<CounterStyle>,
      default: CounterStyle.Default
    },
    label: {
      type: String
    }
  },
  setup (props) {
    const element = ref<HTMLElement>()
    const animationDuration = computed(() => {
      const v = props.value && typeof props.value === 'object' ? props.value.value : props.value
      const ip = Math.max(v, props.interpolate && typeof props.interpolate === 'object' ? props.interpolate.value : props.interpolate)
      return Math.ceil(Math.max( (props.duration / (ip / v)), props.minDuration || 0 ))
    })

    function animate (from?: number) {
      if (!element.value) return
      const svg = select(element.value)

      const text = svg.select('#count_container')
        // .attr('x', (props.value || props.start).toString().length * 130)
        .attr('x', 0)
        .attr('y', props.large ? 19 : 18)
        .text(`${from || props.start}`)
      // text.style('text-anchor', 'middle')
      text.transition()
        .tween('text', function () {
          const selection = select(this)
          const start = parseInt(select(this).text())
          const end = props.value && typeof props.value === 'object' ? props.value.value : props.value
          const interpolator = interpolateNumber(start, end || start)

          return t => { selection.text(`${Math.round(interpolator(t))}`) }
        })
        .duration(animationDuration.value)
    }

    onMounted(() => {
      animate()
    })

    // watchEffect(animate)
    watch(() => props.value !== undefined && ((props.value as Ref)?.value || props.value), (current, prev) => animate(props.track ? prev?.value || 0 : false))

    return {
      element,
      animationDuration
    }
  }
})
